/* eslint-disable @typescript-eslint/no-shadow */
import { odata } from '@bingads-webui/http-util';
// import { Promise } from 'bluebird';

import _ from 'underscore';

interface IOptions {
  cid: number;
  aid: number;
  oDataConfig: any;
}

interface ISocialMediaImage {
  Url: string;
  PostTime: string;
  Width?: number;
  Height?: number;
  Text: string;
}

enum FetchStatus {
  Fetching = 'Fetching',
  Done = 'Done',
}

interface IStatus {
  Status: FetchStatus;
}

interface ISoicalMediaAccountsResponse extends IStatus {
  SocialMediaAccounts: {Key: string, Value: string}[]
}

interface ISoicalMediaImagessResponse extends IStatus {
  SocialMediaImages: {Key: string, Value: ISocialMediaImage[]}[]
}

function poll<T extends IStatus>(callback: () => Promise<T>, timeout: number): Promise<T> {
  function pollInternal<T extends IStatus>(callback: () => Promise<T>, timeout: number, resolve: (val: T) => void) {
    callback().then(response => {
      if (response.Status === FetchStatus.Done) {
        resolve(response);
      } else {
        /* istanbul ignore next */
        setTimeout(() => {
          pollInternal(callback, timeout, resolve);
        }, timeout);
      }
    })
  }

  return new Promise((resolve) => {
    pollInternal(callback, timeout, resolve);
  });
}

export default class SocialMediaRepository {
  cid: number;
  aid: number;
  oDataConfig: any;
  baseURL: string;

  constructor(options: IOptions) {
    this.cid = options.cid;
    this.aid = options.aid;
    this.baseURL = `${options.oDataConfig.odataPath}/Customers(${this.cid})/Accounts(${this.aid})`;
    this.oDataConfig = {
      oDataToken: options.oDataConfig.odataToken,
      oDataTokenType: options.oDataConfig.oDataTokenType,
      applicationName: options.oDataConfig.applicationName,
    };
  }

  getSocialMediaAccounts(url: string): Promise<ISoicalMediaAccountsResponse> {
    const query = {
      Url: url,
    };

    return poll(() => odata.post(`${this.baseURL}/Default.GetSocialMediaAccounts`, _.extend({ data: query }, this.oDataConfig)), 1000);
  }

  getSocialMediaImages(accounts: {Key: string, Value: string}[]): Promise<ISoicalMediaImagessResponse> {
    const query = {
      SocialAccounts: accounts,
    };

    return poll(() => odata.post(`${this.baseURL}/Default.GetSocialMediaImages`, _.extend({ data: query }, this.oDataConfig)), 2000);
  }
}
